
<template>
    <div class="">
        <div class="row">
            <div class="col-md-8">
                <div class="card panel">
                    <div class="card-header headnbtn">
                        <div class="d-flex align-items-center justify-content-between">
                            <h5 class="card-title mb-0 flex-grow-1">Item Detail</h5>
                            <a href="javascript:void(0);" @click="openEditProductModal(productData.id)" class="edit_btn" title="Edit Product" :data-id="productData.id"><i class="ri-edit-fill me-1"></i></a>

                            <!-- <router-link
                                :to="{name: 'editProducts', params: {id: productData.id}}"
                                class="edit_btn" title="Edit Product"><i class="ri-edit-fill me-1"></i></router-link> -->
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="view-customer-hed">
                            <div class="view-customer-icon"></div>
                            <span class="view-rght-txt active-txt"></span>
                        </div>
                        <div class="product-row">
                            <div class="left-blk">
                                <div class="product-details-list">
                                    <div class="product-des">
                                        <h5 class="card-title">Item No :</h5>
                                        <p class="product-no">{{productData.product_num}}</p>
                                    </div>
                                    <div class="product-des">
                                        <h5 class="card-title">Product Name :</h5>
                                        <p class="product-no">{{productData.product_name}}</p>
                                    </div>
                                    <div class="product-des">
                                        <h5 class="card-title">Item Description :</h5>
                                        <div v-html="productData.product_desc"></div>
                                    </div>
                                    

                                </div>
                            </div>


                            <div class="right-blk">
                                <div class="product-details-list">
                                    <div class="product-des">
                                        <h5 class="card-title">Customer :</h5>
                                        <p class="product-no">{{productData.customer ? productData.customer.company_name : ''}}</p>
                                    </div>

                                    <div class="product-des">
                                        <h5 class="card-title">Vendor :</h5>
                                        <p class="product-no">{{productData.vendor ? productData.vendor.company_name : ''}}</p>
                                    </div>

                                    
                                    <div class="product-des">
                                        <h5 class="card-title">Customer SKU :</h5>
                                        <p class="product-no">{{productData.customer_sku}}</p>
                                    </div>
                                    <div class="product-des last-child">
                                        <h5 class="card-title">Cost:</h5>
                                        <p class="product-no">${{productData.vendor_cost}}</p>
                                    </div>
                                    <div class="product-des">
                                        <h5 class="card-title">Selling :</h5>
                                        <p class="product-no">${{productData.selling}}</p>
                                    </div>
                                    
                                    <div class="product-des last-child">
                                        <h5 class="card-title">UOM:</h5>
                                        <p class="product-no">{{ productData.unit_data ? productData.unit_data.name : "" }}</p>
                                    </div>

                        

                                </div>
                            </div>
                        </div>

                    </div>

                    <!-- <div class="card-body">
                        <div class="view-customer-hed">
                            <div class="view-customer-icon"></div>
                            <span class="view-rght-txt active-txt"></span>
                            <h2>Invetory</h2>
                        </div>
                        <div class="left-blk">
                            <div class="product-details-list">
                                <div class="product-des">
                                    <h5 class="card-title">Warehouse</h5>
                                    <p class="product-no">65000</p>
                                </div>
                                <div class="product-des">
                                    <h5 class="card-title">In Transit</h5>
                                    <p class="product-no">1000</p>
                                </div>
                                <div class="product-des">
                                    <h5 class="card-title">On Order</h5>
                                    <p class="product-no">{{ tolalQuantity }}</p>
                                </div>
                                

                            </div>
                        </div>


                        


                    </div> -->

                </div>
                <template v-if="productData.artwork">
                    <template v-if="productData.artwork.products.length > 0">
                        <div class="card panel">
                        <div class="card-header headnbtn">
                            <div class="d-flex align-items-center justify-content-between">
                                <h5 class="card-title mb-0 flex-grow-1">Artwork Status</h5>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="artworkDetailsrow product-details-list">
                                <div class="product-des">
                                    <h5 class="card-title">SO No:</h5>
                                    <p class="product-no"><a href="#"><router-link target="_blank" :to="{ name: 'orderShow', params: { id: productData.artwork.id }}" class="edit-btn">#{{productData.artwork.order_number}}</router-link></a></p>
                                </div>
                                <div class="product-des">
                                    <h5 class="card-title">Artwork File Name: {{productData.artwork.products[0].artworks[0] ? productData.artwork.products[0].artworks[0].attach_link : ''}}</h5>

                                </div>
                                <div class="product-des">
                                    <h5 class="card-title">Updated At:{{productData.artwork.products[0].artworks[0] ? productData.artwork.products[0].artworks[0].updated_at : ''}}</h5>
                                    <!-- <p class="product-no"></p> -->
                                </div>
                                <div class="product-des">
                                    <h5 class="card-title">Status:{{productData.artwork.products[0].artworks[0] ? productData.artwork.products[0].artworks[0].artwork_status.name : ''}}</h5>
                                    <!-- <p class="product-no"></p> -->
                                </div>
                                <div class="product-des">
                                    <h5 class="card-title">Actions:</h5>
                                    <p class="product-no" >
                                    <template v-if="productData.artwork.products[0].artworks[0].attach_link">
                                        <a v-if="['png', 'jpg', 'jpeg'].some( image => productData.artwork.products[0].artworks[0].attach_link.toLowerCase().includes(image))" href="javascript:void(0);" @click="imagePreview(productData.artwork.products[0].artworks[0].attach_link,productData.artwork.id)" class="btn custom-btn">Preview</a>
                                    </template>
                                    
                                    <a href="javascript:void(0);" v-on:click="download(productData.artwork.products[0].artworks[0],productData.artwork.id)" class="btn custom-btn">Download</a></p>
                                </div>

                            </div>
                        </div>
                    </div>
                    </template>
                </template>

                <LightBox :media="previewMedia" :showLightBox="false" :showThumbs="false" ref="lightbox"></LightBox>
            </div>
            <div class="col-md-4">
            <div class="card">
                    <div class="card-header border-0">
                        <div class="d-flex align-items-center">
                            <h5 class="card-title mb-0 flex-grow-1">Orders History</h5>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="table-responsive product-create table-card">
                            <table class="table table-custom align-middle table-nowrap mb-0">
                                <thead>
                                <tr>
                                    <th>Created</th>
                                    <th style="width: 140px">Order #</th>
                                    <th>Quantity</th>


                                </tr>
                                </thead>
                                <template v-if="orderData != null && orderData.data.length > 0">
                                    <template v-for="(item, index) in orderData.data">
                                        <tr :id="item.id" :key="item.id">
                                            <td>{{ item.created_at_date }}</td>
                                            <td>
                                                <router-link :to="{ name: 'orderShow', params: { id: item.id }}" class="edit-btn">#{{ item.order_number }}</router-link>
                                            </td>
                                            <td>
                                                {{getProductQuantity(item)}}
                                            </td>
                                        </tr>
                                    </template>
                                </template>

                            </table>

                            <div class="btnrow text-left" v-if="orderData != null && orderData.data.length">
                                <template>
                                    <div class="overflow-auto">
                                        <b-pagination
                                            v-model="current_page"
                                            :total-rows="total"
                                            :per-page="per_page"
                                        ></b-pagination>
                                    </div>
                                </template>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

        </div>

        <!-- Order List  -->
        <!-- <div class="mb-1 row">

            <div class="col-md-7">
                <div class="card">
                    <div class="card-header border-0">
                        <div class="d-flex align-items-center">
                            <h5 class="card-title mb-0 flex-grow-1">Inventory Activity</h5>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="table-responsive product-create table-card">
                            <table class="table table-custom align-middle table-nowrap mb-0">
                                <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>Action</th>
                                    <th>From</th>
                                    <th>To</th>
                                    <th>Quantity</th>
                                    <th>Stocking Terms Up</th>
                                    


                                </tr>
                                </thead>
                                <template v-if="orderData != null && orderData.data.length > 0">
                                <tr>
                                    <td>03/26/2023</td>
                                    <td>Receiving</td>
                                    <td>Vendor Name</td>
                                    <td>Warehouse Name</td>
                                    <td>+25000</td>
                                    <td>06/26/2023</td>
                                </tr>
                                    <template v-for="(item, index) in orderData.data">
                                        <tr :id="item.id" :key="item.id">
                                            <td>{{ item.created_at_date }}</td>
                                            <td>
                                                <router-link :to="{ name: 'orderShow', params: { id: item.id }}" class="edit-btn">#{{ item.order_number }}</router-link>
                                            </td>
                                            <td>
                                                {{getProductQuantity(item)}}
                                            </td>
                                        </tr>
                                    </template>
                                </template>

                            </table>

                            <div class="btnrow text-left" v-if="orderData != null && orderData.data.length">
                                <template>
                                    <div class="overflow-auto">
                                        <b-pagination
                                            v-model="current_page"
                                            :total-rows="total"
                                            :per-page="per_page"
                                        ></b-pagination>
                                    </div>
                                </template>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div class="col-md-5"></div>
        </div> -->
        <!-- Order list ends here -->

        <!-- Order List  -->
        <div class="mb-1 row">

            <div class="col-md-7">
                
            </div>
            <div class="col-md-5"></div>
        </div>
        <!-- Order list ends here -->
        <ProductEditModal @productDataSaved="customerDataSaved($event)" :options="optionvs" :optionsCustomer="optionsCustomer" :form_new="form"></ProductEditModal>
    </div>
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex';
import LightBox from 'vue-it-bigger';
import axios from "axios";
import ProductEditModal from "./ProductEditModal";
export default {
    name: "ProductDetail",
    components: {
        LightBox,ProductEditModal
    },
    props: ['productData'],
    created() {
        //console.log("check productData ",this.productData.vendor_cost);
        this.getSlesOrders();
    },
    data(){
        return {
            tolalQuantity:0,
            previewMedia: [],
            orderData:{
                data:[]
            },
            current_page:1,
            per_page:10,
            total:0,
            optionvs:[],
            optionsCustomer:[],
             form: {
                id:null,
                qty_unit_id:null,
                product_name: null,
                price: null,
                product_desc: null,
                product_num: null,
                vendor_id: null,
                customer_id: null,
                selling: null,
                status:"1",
                vendor_cost:null,
                sku: null,
                customer_sku: null,
            },
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setCustomers',
            'setCustomerLoading',
            'setLoading'
        ]),
        customerDataSaved(updatedProduct){
            location.reload();
        },
        openEditProductModal(productId){
            this.productId = productId;
            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            //this.setSuccessMessage(null);
            return axios.get(window.route('products.show', {id: productId}), {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errors){
                        self.setCommonErrors(data.errors);
                    } else if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                    } else {
                       // this.customerData = data.data;
                        console.log("this.customerData 11",data);
                         this.form = {
                            id: data.data.id,
                            qty_unit_id:data.data.unit_id,
                            product_name: data.data.product_name,
                            product_desc: data.data.product_desc,
                            price: data.data.price,
                            product_num: data.data.product_num,
                            vendor_id: data.data.vendor_id,
                            customer_id: data.data.customer_id,
                            selling: data.data.selling,
                            status:data.data.status,
                            vendor_cost:data.data.vendor_cost,
                             sku: data.data.sku,
                             customer_sku: data.data.customer_sku,
                         }
                         if(data.data.vendor){
                            this.optionvs = [
                                {
                                id:data.data.vendor.id,
                                company_name:data.data.vendor.company_name
                                }
                            ];
                         }
                         if(data.data.customer){
                            this.optionsCustomer = [
                                {
                                id:data.data.customer.id,
                                company_name:data.data.customer.company_name
                                }
                            ];
                         }

                        console.log("this.form ",this.form );
                        console.log("this.optionvs ",this.optionvs );
                         $('#productEditModal').modal('show');


                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setCustomerLoading(false);

                });

            
        },

         download(artwork,soId) {
            let url = window.route('medias.download', {
                path: 'so_attachments',
                id: soId,
                name: artwork.attach_link,
                pdf_to_image: 0
            });

            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(url, {
                responseType: "blob",
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    self.setLoading(false);
                    // Service that handles ajax call
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("target", "_blank");
                    link.setAttribute("download", artwork.attach_link);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        imagePreview(src,soId) {
            let url = window.route('medias.view', {
                path: 'so_attachments',
                id: soId,
                name: src
            });
            this.previewMedia = [{
                thumb: url,
                src: url,
                caption: '', // Optional
                //srcset: '...' // Optional for displaying responsive images
            }];
            this.$refs.lightbox.showImage(0)
        },
        getSLNo(index) {
            return Number(this.productData.config['start_from']) + index;
        },
        getProductQuantity(order) {
            let products = order.products.filter((x) => x.product_id == this.$route.params.id);
            //console.log(products)
            if(products.length) {
                return products[0].quantity;
            }
            return 0;
        },
        getSlesOrders(){

            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('products.so', {id: this.$route.params.id, page: this.current_page}), {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errors.length > 0){

                        self.setCommonErrors(data.errors);
                    } else if(data.errorMessage){

                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.orderData = data.data.orders;
                        console.log('order details ',this.orderData);
                        this.tolalQuantity = this.orderData.data.reduce((sum, order) => {
                        return sum + order.products.reduce((subSum, product) => subSum + product.quantity, 0);
                        }, 0);

                        


                        this.current_page = data.data.orders.current_page;
                        this.per_page = data.data.orders.per_page;
                        this.total = data.data.orders.total;
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setCustomerLoading(false);

                });
        },
    },
    computed: {
        ...mapState([
            'userState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage'
        ])
    },
    watch: {
        current_page: {
            handler: function(afterValue, beforeValue) {
                if(afterValue !== 1){
                    this.getSlesOrders();
                }
            }
        }
    }
}
</script>

<style scoped>

</style>
